<template>
  <div class="container">
    <div class="row">
      <!-- edit account -->
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <account-users :users="account.users" title="Account users"></account-users>
      </div>
      <!-- list account users -->
      <!-- list account invitations -->
    </div>
    <div class="row">
      <!-- delete account -->
    </div>
  </div>
</template>

<script>
import AccountUsers from "./AccountUsers";

export default {
  components: {
    AccountUsers
  },
  computed: {
    account: function() {
      return this.$ls.get("account");
    }
  }
};
</script>
<style>
</style>  